let dayMap = {
  '星期一': 1,
  '星期二': 2,
  '星期三': 3,
  '星期四': 4,
  '星期五': 5,
  '星期六': 6,
  '星期天': 7
}
let hourMap = (function () {
  let map = {}
  for (let i = 0; i <= 24; i++) {
    if (i < 10) {
      map['0' + i] = i
    }
    map[i + ''] = i
  }
  return map
})()
let minuteMap = (function () {
  let map = {}
  for (let i = 0; i <= 60; i++) {
    if (i < 10) {
      map['0' + i] = i
    }
    map[i + ''] = i
  }
  return map
})()
let secondMap = (function () {
  let map = {}
  for (let i = 0; i <= 60; i++) {
    if (i < 10) {
      map['0' + i] = i
    }
    map[i + ''] = i
  }
  return map
})()

export default{
  stTimeRule (period) {
    let stDay = dayMap[period.stDay]
    let stHour = hourMap[period.stHour]
    let stMinute = minuteMap[period.stMinute]
    let stSecond = secondMap[period.stSecond]
    let edDay = dayMap[period.edDay]
    let edHour = hourMap[period.edHour]
    let edMinute = minuteMap[period.edMinute]
    let edSecond = secondMap[period.edSecond]
    let stSum = stDay * 24 * 60 * 60 + stHour * 60 * 60 + stMinute * 60 + stSecond
    let edSum = edDay * 24 * 60 * 60 + edHour * 60 * 60 + edMinute * 60 + edSecond
    return (stSum <= edSum) || '开始时间不能大于结束时间'
  },
  edTimeRule (period) {
    let stDay = dayMap[period.stDay]
    let stHour = hourMap[period.stHour]
    let stMinute = minuteMap[period.stMinute]
    let stSecond = secondMap[period.stSecond]
    let edDay = dayMap[period.edDay]
    let edHour = hourMap[period.edHour]
    let edMinute = minuteMap[period.edMinute]
    let edSecond = secondMap[period.edSecond]
    let stSum = stDay * 24 * 60 * 60 + stHour * 60 * 60 + stMinute * 60 + stSecond
    let edSum = edDay * 24 * 60 * 60 + edHour * 60 * 60 + edMinute * 60 + edSecond
    return (stSum <= edSum) || '结束时间不能小于开始时间'
  },
  haveMutiplePeriod (periodArray, data) {
    if (periodArray.length === 1) {
      return true
    }
    let flag = true
    let stDay = dayMap[data.stDay]
    let stHour = hourMap[data.stHour]
    let stMinute = minuteMap[data.stMinute]
    let stSecond = secondMap[data.stSecond]
    let edDay = dayMap[data.edDay]
    let edHour = hourMap[data.edHour]
    let edMinute = minuteMap[data.edMinute]
    let edSecond = secondMap[data.edSecond]
    let stDataSum = stDay * 24 * 60 * 60 + stHour * 60 * 60 + stMinute * 60 + stSecond
    let edDataSum = edDay * 24 * 60 * 60 + edHour * 60 * 60 + edMinute * 60 + edSecond
    for (let i = 0; i < periodArray.length; i++) {
      let period = periodArray[i]
      let stDay = dayMap[period.stDay]
      let stHour = hourMap[period.stHour]
      let stMinute = minuteMap[period.stMinute]
      let stSecond = secondMap[period.stSecond]
      let edDay = dayMap[period.edDay]
      let edHour = hourMap[period.edHour]
      let edMinute = minuteMap[period.edMinute]
      let edSecond = secondMap[period.edSecond]
      let stSum = stDay * 24 * 60 * 60 + stHour * 60 * 60 + stMinute * 60 + stSecond
      let edSum = edDay * 24 * 60 * 60 + edHour * 60 * 60 + edMinute * 60 + edSecond
      if ((stDataSum < stSum && edDataSum > edSum) || (stDataSum > stSum && stDataSum < edSum) || (stDataSum < edSum && edDataSum > edSum)) {
        flag = false
        break
      }
    }
    return flag || '时间段存在冲突'
  },
  checkPerWeek (periodArray) {
    let sum = 0
    for (let i = 0; i < periodArray.length; i++) {
      let period = periodArray[i]
      let stDay = dayMap[period.stDay]
      let stHour = hourMap[period.stHour]
      let stMinute = minuteMap[period.stMinute]
      let stSecond = secondMap[period.stSecond]
      let edDay = dayMap[period.edDay]
      let edHour = hourMap[period.edHour]
      let edMinute = minuteMap[period.edMinute]
      let edSecond = secondMap[period.edSecond]
      let stSum = stDay * 24 * 60 * 60 + stHour * 60 * 60 + stMinute * 60 + stSecond
      let edSum = edDay * 24 * 60 * 60 + edHour * 60 * 60 + edMinute * 60 + edSecond
      sum += (edSum - stSum)
    }
    return sum % 604800 === 0
  },
  checkPerDay (periodArray) {
    let sum = 0
    for (let i = 0; i < periodArray.length; i++) {
      let period = periodArray[i]
      let stDay = dayMap[period.stDay]
      let stHour = hourMap[period.stHour]
      let stMinute = minuteMap[period.stMinute]
      let stSecond = secondMap[period.stSecond]
      let edDay = dayMap[period.edDay]
      let edHour = hourMap[period.edHour]
      let edMinute = minuteMap[period.edMinute]
      let edSecond = secondMap[period.edSecond]
      let stSum = stDay * 24 * 60 * 60 + stHour * 60 * 60 + stMinute * 60 + stSecond
      let edSum = edDay * 24 * 60 * 60 + edHour * 60 * 60 + edMinute * 60 + edSecond
      sum += (edSum - stSum)
    }
    return sum % 86400 === 0
  },
  printData () {
    console.log(dayMap)
    console.log(hourMap)
    console.log(minuteMap)
    console.log(secondMap)
  }
}
